<template>
  <div>

    <template v-for="(row, index) in parcels">
      <div class="row" :key="index">
        <div class="col-5">
          <number-input v-model="row.value" alias="Valor" />
        </div>
        <div class="col-2">
          <text-input v-model="row.days" :decimal-places="0" :minimumValue="-999999999" alias="Prazo (dias)" @input="updateDate(index)"/>
        </div>
        <div class="col-4">
          <date-input v-model="row.due_date" alias="Vencimento" @input="updateDays(index)"/>
        </div>
        <div class="col-1">
            <div class="form-group">
              <label class="control-label">&nbsp;</label>
              <br>
              <button v-if="hasMoreThanOnRow" class="btn btn btn-light" @click="removeRow(index)">
                <i class="text-info fas fa-times"></i>
              </button>
            </div>
          </div>
      </div>
    </template>

    <div class="row">
      <div class="col-md-6">
        <button class="btn btn-link text-info" @click="addRow">
          <i class="fas fa-plus" /> Adicionar parcela
        </button>
      </div>
    </div>

  </div>
</template>

<script>

import moment from "moment";

export default {
  props : {
    value : {}
  },

  data: function() {
    return {
      parcels : [
        {
          value: null,

          days: 0,

          due_date: null,
        }
      ]
    };
  },

  watch : {
    value(val) {
      this.parcels = val
    },

    parcels : {
      handler(val){
        this.$emit('input', val)
      },
      deep: true
    }
  },

  computed : {
    hasMoreThanOnRow() {
      return (this.parcels.length > 1)
    }
  },

  methods: {
    addRow() {
      this.parcels.push({
          value: null,

          days: 0,

          due_date: null,
        })
    },

    removeRow(index) {
      this.$delete(this.parcels, index);
    },

    updateDate(index) {
      this.parcels[index].due_date = moment({h:0, m:0, s:0, ms:0}).add(this.parcels[index].days, 'd').format('YYYY-MM-DD')
    },

    updateDays(index) {

      var due_date = moment(this.parcels[index].due_date , 'YYYY-MM-DD');

      this.parcels[index].days = (due_date.diff(moment({h:0, m:0, s:0, ms:0}), 'd'))

    },
  }


};
</script>

<style>
</style>
